import { render, staticRenderFns } from "./alert-dialog.vue?vue&type=template&id=5e2f5cf0&scoped=true"
import script from "./alert-dialog.vue?vue&type=script&lang=js"
export * from "./alert-dialog.vue?vue&type=script&lang=js"
import style0 from "./alert-dialog.vue?vue&type=style&index=0&id=5e2f5cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f5cf0",
  null
  
)

export default component.exports